import { Component } from 'react'

// Last line of defence: a render crash on one page shows a recoverable message
// instead of a blank white/black screen for the whole app.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('UI crash:', error, info?.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#08090c', color: '#ececee', fontFamily: 'Inter, system-ui, sans-serif', padding: 24 }}>
        <div style={{ maxWidth: 420, textAlign: 'center' }}>
          <h1 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>Something broke on this page</h1>
          <p style={{ color: '#8b8d94', fontSize: 14, marginTop: 8 }}>Reloading usually fixes it. If it keeps happening, tell the dev team what you clicked.</p>
          <button onClick={() => window.location.reload()} style={{ marginTop: 20, height: 40, padding: '0 20px', borderRadius: 999, background: '#fff', color: '#08090c', fontWeight: 600, border: 0, cursor: 'pointer' }}>Reload</button>
        </div>
      </div>
    )
  }
}
